import { useState } from 'react';
import { toast } from "sonner";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/modules/shared/ui/components/alert-dialog";
import { SendChangePasswordLinkAsync } from "@/modules/auth/infrastructure/auth-service";

interface ChangePasswordConfirmDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void
}

export const ChangePasswordConfirmDialog = ({
    open,
    onOpenChange
}: ChangePasswordConfirmDialogProps) => {
    const [isSending, setIsSending] = useState(false)

    const handleConfirm = async () => {
        try {
            setIsSending(true)
            const result = await SendChangePasswordLinkAsync()
            toast.success(result.message ?? "Password change link sent to your email.")
            onOpenChange(false)
        } catch {
            toast.error("Failed to send password change link. Please try again later.")
        } finally {
            setIsSending(false)
        }
    }

    return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Change your password?</AlertDialogTitle>
          <AlertDialogDescription>
            We'll send a secure link to your email. Click it to choose a new password.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isSending}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={isSending}>
            {isSending ? "Sending..." : "Send link"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}